import React from 'react';
import { useSelector } from 'react-redux';
import yellowCircle from '../../../../../../assests/notAuth/yellowCircle.png'
import StarCircle from '../../../../../../shared/components/ui/iconsOld/StarCircle';
import Text from '../../../../../../shared/components/features/text/Text';
import NotAuthButton from '../../../../notAuthButton/NotAuthButton';
import useTextByLangAndGender from '../../../../../../shared/hooks/useTextByLangAndGender';
import classes from './ImageTextSection.module.css';

const ImageTextSection = ({ img, title, description, buttons, directionContent, iconText, iconColor, iconTextColor, iconTextSize, bgImg, beforeTitle }) => {

    const textByLangAndGender = useTextByLangAndGender();
    const { texts } = useSelector(state => state.translate);

    const isVideoFile = img && (img.endsWith('.mp4') || img.endsWith('.webm') || img.endsWith('.mov'));

    return (
        <div className={`${classes.ImageTextSection} ${classes.InfoSection}`} style={{ backgroundImage: `url(${bgImg})` }}>
            <div className={`${classes.Section} ${classes[`${directionContent}Content`]}`}>
                {isVideoFile ?
                    <video className={classes.Image} autoPlay loop muted playsInline preload="metadata">
                        <source src={img} type={img.endsWith('.webm') ? 'video/webm' : 'video/mp4'} />
                    </video> :
                    <img className={classes.Image} src={img} alt={textByLangAndGender(title)} loading="lazy" />}

                <div className={classes.Content}>
                    <div className={classes.Title}>
                        {iconText && <div className={classes.IconWrapper} >
                            <StarCircle className={classes.Icon} src={yellowCircle} color={iconColor} />
                            <Text className={classes.IconText} style={{ fontSize: iconTextSize ? iconTextSize : "24px", color: iconTextColor ? iconTextColor : "#FFF" }}>{texts[iconText]}</Text>
                        </div>}
                        <Text className={classes.BeforeTitleText}>{texts[beforeTitle]}</Text>
                        <Text className={classes.TitleText} dangerouslySetInnerHTML>{title}</Text>
                    </div>
                    <div className={classes.Description}>
                        {description && <Text elementType='span' className={classes.Text} dangerouslySetInnerHTML>{description}</Text>}
                    </div>
                    <div className={buttons?.length > 1 ? classes.ButtonsContainer : ''}>
                        {buttons?.map((button, index) => <NotAuthButton key={index} text={button.text} link={button.link} icon={button.icon} className={classes.Btn} newTab={button.newTab} checkLogin={button.checkLogin} popup={button.popup} showLoadingPage={button.showLoadingPage} />)}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ImageTextSection;
